import React, { Component } from 'react';
import { fromJS } from 'immutable';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import Moment from 'moment';
import DatePicker from 'react-datepicker';

import * as LocalStorage from '../../../utils/localStorageHelper';
import * as GoogleMapApi from '../../../utils/googleApiHelper';
import PageTitle from '../../../components/commons/pages/PageTitle';
import ProductList from '../../../components/cart/ProductList';
import ProductListMobile from '../../../components/cart/ProductListMobile';
import BillDetails from '../../../components/checkout/BillDetails';
import BillDetailsMobile from '../../../components/cart/BillDetailsMobile';
import DeliveryDetailsMobile, { slots } from '../../../components/checkout/DeliveryDetailsMobile';
import PaymentCards from '../../../components/checkout/PaymentCards';
import PaymentCardsMobile from '../../../components/checkout/PaymentCardsMobile';
import Loader from '../../../components/commons/loader/loader';
import Spinner from '../../../components/commons/spinner/spinner';
import * as User from '../../../utils/userHelpers';
import * as Cart from '../../../utils/cartHelper';
import * as Orders from '../../../utils/ordersHelper';
import * as Payments from '../../../services/payments';
import * as OrdersActions from '../../../actions/ordersActions';
import * as PaymentsActions from '../../../actions/paymentsActions';
import * as Utils from '../../../utils/utils';
import SweetAlert from 'sweetalert-react';
import * as UserActions from '../../../actions/userActions';
import SimpleModal from '../../../components/commons/modals/SimpleModal';
import PlacePicker, { validateLatLongForDelivery } from '../../../components/commons/place-picker/PlacePicker';
import withSizes from 'react-sizes';
import Moment from 'moment-timezone';
import ApplePay from "../../../components/checkout/ApplePay";

class ReviewOrderPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserLoggedIn: false,
      cartItems: {},
      billDetails: {},
      isDeliveryDetailsEditable: false,
      isPaymentInfoEditable: false,
      isBillingAddressEditable: false,
      newCardData: {},
      selectedCard: false,
      deliveryNotes: '',
      deliveryTime: Moment(),
      isTimeNowSelected: true,
      isDeliveryDetailsEdited: false,
      isCopyOfDeliveryAddress: true,
      billingAddress: '',
      showAlert: false,
      placeOrderSuccess: false,
      swalParams: {
        title: ""
      },
      giftDelivery: false,
      userAddresses: [],
      recipientName: "",
      recipientPhone: "",
      recipientEmail: "",
      recipientBusinessName: "",
      giftMessage: "",
      senderName: "",
      senderEmail: "",
      senderPhone: "",
      senderBusinessName: "",
      senderDOB: undefined,
      receiverAddressModal: false,
      senderAddressModal: false,
      deliveryValidationStatus: {
        status: true,
        time: 0,
        region: "NA"
      },
      deliverySlot: "morning",
      isReady: false,
      displayValue: false,
      errorsWhileApplePay: false,
      userName: '',
      shippoResult: [],
      selectedShipment: {},
      makeCardActive: false,
      stripe: undefined,
      userDob:''
    };


    this.renderContentIfCartHasProducts = this.renderContentIfCartHasProducts.bind(this);
    this.renderContentIfCartHasProductsForMobile = this.renderContentIfCartHasProductsForMobile.bind(this);
    this.renderNoProductsInCartMessage = this.renderNoProductsInCartMessage.bind(this);
    this.renderUserNotLoggedInMessage = this.renderUserNotLoggedInMessage.bind(this);
    this.renderOrderSuccessMessage = this.renderOrderSuccessMessage.bind(this);
    this.updateCart = this.updateCart.bind(this);
    this.onChangeProductQuantity = this.onChangeProductQuantity.bind(this);
    this.addPaymentCard = this.addPaymentCard.bind(this);
    this.onPaymentInfoEditDone = this.onPaymentInfoEditDone.bind(this);
    this.renderDeliveryToAddress = this.renderDeliveryToAddress.bind(this);
    this.renderScheduleDelivery = this.renderScheduleDelivery.bind(this);
    this.renderDeliveryNotes = this.renderDeliveryNotes.bind(this);
    this.onDeliveryDetailsEditDone = this.onDeliveryDetailsEditDone.bind(this);
    this.onBillingAddressEditDone = this.onBillingAddressEditDone.bind(this);
    this.placeOrder = this.placeOrder.bind(this);
    this.getPlaceOrderDetails = this.getPlaceOrderDetails.bind(this);
    this.onStripeCheckoutSubmit = this.onStripeCheckoutSubmit.bind(this);
    this.goBack = this.goBack.bind(this);
    this.deleteProduct = this.deleteProduct.bind(this);
    this.addNewAddress = this.addNewAddress.bind(this);
    this.restoreStoredAddresses = this.restoreStoredAddresses.bind(this);
    this.renderGiftDeliveryDetails = this.renderGiftDeliveryDetails.bind(this);
    this.openReceiverAddressModal = this.openReceiverAddressModal.bind(this);
    this.closeReceiverAddressModal = this.closeReceiverAddressModal.bind(this);
    this.openSenderAddressModal = this.openSenderAddressModal.bind(this);
    this.closeSenderAddressModal = this.closeSenderAddressModal.bind(this);
    this.validateGiftDeliveryDetails = this.validateGiftDeliveryDetails.bind(this);
    this.onGiftSwitchToggle = this.onGiftSwitchToggle.bind(this);
    this.setCartGiftDeliveryDetails = this.setCartGiftDeliveryDetails.bind(this);
    this.onSlotChange = this.onSlotChange.bind(this);
    this.resetShippingState = this.resetShippingState.bind(this);
    this.calculateShipping = this.calculateShipping.bind(this);
    this.shipmentSelected = this.shipmentSelected.bind(this);
    this.validateDelivery = this.validateDelivery.bind(this);
    this.validateDeliveryForCheckoutSession = this.validateDeliveryForCheckoutSession.bind(this);
    this.addressUpdated = this.addressUpdated.bind(this);
    this.IsAddressOutside = this.IsAddressOutside.bind(this);
    this.setPriceUpdate = this.setPriceUpdate.bind(this);
  }

  componentDidMount() {

    const that = this;
    if (!window.Stripe) {
      const stripeJs = document.createElement("script");
      stripeJs.src = "https://js.stripe.com/v3/";
      stripeJs.async = true;
      stripeJs.onload = () => {
        that.setState({
          // eslint-disable-next-line no-undef
          stripe: window.Stripe(WP_STRIPE_PL),
        });
      };
      document.body.appendChild(stripeJs);
    } else {
      that.setState({
          // eslint-disable-next-line no-undef
          stripe: window.Stripe(WP_STRIPE_PL),
      });
    }

    if (!User.isLoggedIn()) {
      return;
    } else {
      this.setState({ isUserLoggedIn: true });
    }
    let cart = Cart.getCartAttribute(Cart.ATTRIBUTE_CART_STORE);
    let cartItems = Cart.getCartAttribute(Cart.ATTRIBUTE_CART_ITEMS);
    let deliveryTime = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_TIME);
    let deliveryNotes = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_NOTES);
    let deliverySlot = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_SLOT);
    let isSameAsDeliveryAddress = Cart.getCartAttribute(Cart.ATTRIBUTE_IS_SAME_AS_DELIVERY_ADDRESS);
    let deliveryAddress = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_ADDRESS);
    let tipPercentage = Cart.getCartAttribute(Cart.ATTRIBUTE_TIP_PERCENT);
    let giftDeliveryDetails = Cart.getCartAttribute(Cart.ATTRIBUTE_GIFT_DELIVERY_DETAILS);
    let giftDelivery = Cart.getCartAttribute(Cart.ATTRIBUTE_GIFT_DELIVERY);

    const products = Object.values(cartItems).map(i => ({
      id: i._id,
      name: i.Description,
      ...i
    }));
    window.dataLayer.push({
      event: 'checkout',
      ecommerce: { checkout: { actionField: { step: 1 }, products } }
    });

    this.props.dispatch(UserActions.getProfileDetails(response => {
      if (response.status) {
        let user = response.data;
        this.setState({
          userName: user.name.first + " " + user.name.last,
          userEmail: user.email,
          userPhone: user.phone,
          userDob: user.dob,
          userAddresses: user
            ? user.addresses
            : []
        }, () => {
          // delivery addresses are no editable
          // double check the address from cart
          if (deliveryAddress) {
            deliveryAddress = this.state.userAddresses.find(a => a._id === deliveryAddress._id);
            if (deliveryAddress) {
              this.onSelectUserAddress(deliveryAddress);
            }
          }

          this.restoreStoredAddresses();
      });
      }
    }))
    if(giftDeliveryDetails && giftDeliveryDetails.senderDOB) {
      giftDeliveryDetails.senderDOB = Moment(giftDeliveryDetails.senderDOB)
    }

    this.setState({
      cartItems: cartItems,
      deliveryTime: deliveryTime && deliveryTime.start
        ? (deliveryTime.start === 'now'
          ? Moment()
          : Moment(deliveryTime.start))
        : Moment(),
      isTimeNowSelected: deliveryTime && deliveryTime.start === 'now',
      isCopyOfDeliveryAddress: isSameAsDeliveryAddress,
      deliveryNotes: deliveryNotes,
      tipPercentage: tipPercentage,
      ...giftDeliveryDetails,
      giftDelivery,
      deliverySlot,
    });

    // jugaad - Placepicker isn't fully initialized yet :(
    // this shouldn't be a state variable at all :/
    setTimeout(() => {
      if (deliveryAddress) {
        const deliveryValidationStatus = validateLatLongForDelivery({
          lat: deliveryAddress.loc[1],
          lng: deliveryAddress.loc[0],
        }, 'GIFT');
        this.setState({
          deliveryValidationStatus: {
            ...deliveryValidationStatus,
            time: deliveryValidationStatus.time < 12 ? 0 : 48,
            // only used for normal deliveries in extended areas
            // intentionally changed to 2 business days
            // read JSDoc - validateLatLongForDelivery
            timeDisplay: deliveryValidationStatus.time < 12 ? '' : '2 days'
          },
          deliverySlot: deliveryValidationStatus.time < 12 ? '' : deliverySlot || 'morning',
        });
      } 
    }, 2000);

    this.props.dispatch(OrdersActions.setDeliveryPlace(deliveryAddress));

    this.props.dispatch(PaymentsActions.requestStripeCustomer(response => {
      if (response.status) {
        let cards = response.data.sources.data;
        let defaultCardId = response.data.default_source;
        let selectedCard = Payments.getPaymentMethodById(defaultCardId, cards);
        this.setState({ selectedCard: selectedCard });
      } else {
        // this.setState({
        //   showAlert: true,
        //   swalParams: {
        //     title: (response.data.error
        //       ? response.data.error.message
        //       : 'Something went wrong!'),
        //     type: "error",
        //     showConfirmButton: false
        //   }
        // })
      }
    }))

    this.doOnCartChanged(cart);
    window.addEventListener('cart_changed', this.updateCart);

    window.addEventListener('address_changed', this.addressUpdated);
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('cart_changed', this.updateCart);

    window.addEventListener('address_changed', this.addressUpdated);
  }


  render() {
    const { isReady, isUserLoggedIn, cartItems, swalParams, showAlert, placeOrderSuccess } = this.state;
    const { loading, isMobile, recentOrder } = this.props;
    const cartItemList = cartItems ? Object.values(cartItems) : [];

    console.log('REVIEW_ORDER_PAGE_STATE', this.state);
    // console.log('REVIEW_ORDER_PAGE_PROPS', this.props);

    return (
      <div className={`page checkout-page ${isMobile ? 'mobile' : ''}`}>
        <div className="container">
          <PageTitle title="Review & Place Order" isMobile />
          {isUserLoggedIn
            ? (cartItemList.length > 0 && !placeOrderSuccess)
              ? isMobile
                ? this.renderContentIfCartHasProductsForMobile(cartItemList)
                : this.renderContentIfCartHasProducts(cartItemList)
              : null
            : this.renderUserNotLoggedInMessage()}
          {placeOrderSuccess && recentOrder && isUserLoggedIn && isReady
            ? this.renderOrderSuccessMessage()
            : null}

        </div>
        <Loader visibility={loading} />
        <SweetAlert showCancelButton
          customClass={"with-close"}
          cancelButtonText={"x"}
          onCancel={() => this.setState({ showAlert: false })}
          show={showAlert}
          {...swalParams}
          onConfirm={() => this.setState({ showAlert: false })} />
      </div>
    )
  }

  onSlotChange(deliverySlot) {
    const { deliveryTime } = this.state;
    this.setState({
      deliverySlot,
    }, () => {
      const { deliverySlot } = this.state;
      Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_SLOT, { deliverySlot });
      Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_TIME, { interval: {
        start: Moment(deliveryTime).hour(slots[deliverySlot][0]).toDate(),
        end: Moment(deliveryTime).hour(slots[deliverySlot][1]).toDate(),
      } });
      window.dataLayer.push({
        event: 'checkoutOption',
        ecommerce: { checkout_option: { actionField: { step: 1, option: 'slotChange' } } }
      });
    });
  }

  renderContentIfCartHasProducts(cartItemList) {
    const {
      billDetails,
      isDeliveryDetailsEditable,
      isPaymentInfoEditable,
      giftDelivery,
    } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-md-7 left-col">

            <div className="info-group">
              <div className="info-body">
                <ProductList
                  viewMode="edit"
                  products={cartItemList}
                  onChangeProductQuantity={this.onChangeProductQuantity}
                  onDeleteProduct={this.deleteProduct}
                />
              </div>
            </div>

            <div className="info-group">
              <div className="info-title">Delivery Details</div>
              <div className="info-body">
                {isDeliveryDetailsEditable ? (
                  <div className="option">
                    <input
                      className="tgl tgl-light"
                      id="gift-switch"
                      onChange={this.onGiftSwitchToggle}
                      checked={giftDelivery}
                      type="checkbox"
                    />
                    <label className="tgl-btn" htmlFor="gift-switch"></label>
                    <span className="tgl-btn-label">GIFT DELIVERY</span>
                  </div>
                ) : null}
                {giftDelivery ? (
                  <div className="covid-message">
                    {" "}
                    {/* Due to the Covid-19 circumstance, dates and time are not
                    guaranteed. Thank you for your understanding. */}
                  </div>
                ) : null}
                {giftDelivery
                  ? this.renderGiftDeliveryDetails()
                  : this.renderDeliveryToAddress()}
                {this.renderScheduleDelivery()}
                {this.renderDeliveryNotes()}
              </div>
              <div className="edit-button-container">
                <a
                  href="javascript:void(0)"
                  onClick={() => this.onDeliveryDetailsEditDone()}
                >
                  {isDeliveryDetailsEditable ? "Done" : "Edit"}
                </a>
              </div>
            </div>

            {/* <div className="info-group">
              <div className="info-title">Payment Information </div>
              <div className="info-body">
                {this.renderPaymentInfo()}
                <div className="info-row"></div>
              </div>
              <div className="edit-button-container">
                <a
                  href="javascript:void(0)"
                  onClick={() => this.onPaymentInfoEditDone()}
                >
                  {isPaymentInfoEditable ? "Done" : "Edit"}
                </a>
              </div>
            </div> */}

            {/* <div className="info-group">
              <div className="info-title">Billing Address</div>
              <div className="info-body">
                {this.renderBillingAddress()}
              </div>
              <div className="edit-button-container">
                <a href="javascript:void(0)" onClick={() => this.onBillingAddressEditDone()}>{isBillingAddressEditable
                  ? 'Done'
                  : 'Edit'}</a>
              </div>
            </div> */}

          </div>
          <div className="col-md-5 right-col">
 
            <div className="info-group">
              <div className="info-title">Order Summary</div>
              <div className="info-body">
                <BillDetails
                  viewMode="edit"
                  billDetails={billDetails}
                  onChangeTipPercent={val => this.setState({ tipPercent: val })}
                />
              </div>
            </div>

            <div className="info-group">
              {this.renderDeliveryScheduleInfo()}
            </div>
          
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {!giftDelivery && (
              <div className="text-center text-error">
                MATCHING CREDIT CARD AND ID MUST BE PRESENT FOR ALL DELIVERIES.
              </div>
            )}
            <div className="footer-buttons-container">
            
              <a
                href="javascript:void(0)"
                className="button-back"
                onClick={() => this.goBack()}
              >
                Back
              </a>
              {/* <a
                href="javascript:void(0)"
                className="button-review-order"
                onClick={() => this.placeOrder()}
              >
                Checkout
              </a> */}
              <a 
                className="button-review-order"
                onClick={this.getPlaceOrderDetails}>Checkout</a>
              {/* <ApplePay
                billDetails={billDetails}
                requestFrom={"web"}
                validateDelivery={this.validateDelivery}
                placeOrder={this.placeOrder}
              /> */}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderContentIfCartHasProductsForMobile(cartItemList) {
    const { cards } = this.props;
    const {
      billDetails,
      giftDelivery,
      selectedCard,
      userAddresses,
      deliveryAddress,
      deliveryNotes,
      deliveryTime,
      isTimeNowSelected,
      recipientAddress,
      recipientName,
      recipientEmail,
      recipientPhone,
      recipientBusinessName,
      giftMessage,
      senderAddress,
      senderName,
      senderEmail,
      senderPhone,
      senderBusinessName,
      senderDOB,
      deliveryValidationStatus,
      deliverySlot,
    } = this.state;

    return (
      <div>
        <ProductListMobile
          viewMode="edit"
          products={cartItemList}
          onChangeProductQuantity={this.onChangeProductQuantity}
          onDeleteProduct={this.deleteProduct} />

        <BillDetailsMobile billDetails={billDetails} />

        {/* <div className="section-header">PAYMENT INFORMATION</div>
        <PaymentCardsMobile cards={cards}
          viewMode={'select'}
          onDeleteCard={() => {}}
          onSelectCard={(card) => this.setState({ selectedCard: card })}
          dispatch={this.props.dispatch}
          selectedCard={selectedCard}
          onAddCardRequest={this.addPaymentCard} /> */}

        <div className="section-header">DELIVERY DETAILS</div>

        <DeliveryDetailsMobile
          viewMode={'select'}
          userAddresses={userAddresses}
          deliveryAddress={deliveryAddress}
          onSelectUserAddress={(address) => this.onSelectUserAddress(address)}
          addNewAddress={() => this.addNewAddress()}
          deliveryNotes={deliveryNotes}
          onChangeDeliveryNotes={(text) => this.setState({ deliveryNotes: text })}
          isTimeNowSelected={isTimeNowSelected}
          deliveryTime={deliveryTime}
          deliveryValidationStatus={deliveryValidationStatus}
          deliverySlot={deliverySlot}
          shippoData={this.state.shippoResult}
          onSlotChange={this.onSlotChange}
          onTimeNowSelected={(isSelected) => this.setState({ isTimeNowSelected: isSelected })}
          onDeliveryTimeSelected={(time) => this.setState({ deliveryTime: time }, () => {
            const deliveryTimeInterval = {};
            const { isTimeNowSelected, deliveryTime } = this.state;
            if (isTimeNowSelected) {
              deliveryTimeInterval.start = 'now';
            } else if (deliverySlot) {
              deliveryTimeInterval.start = Moment(deliveryTime)
                .hour(slots[deliverySlot][0]).minute(0);
              deliveryTimeInterval.end = Moment(deliveryTime)
                .hour(slots[deliverySlot][1]).minute(0);
            } else {
              deliveryTimeInterval.start = Moment(deliveryTime);
              deliveryTimeInterval.end = Moment(deliveryTime).add(60, 'minutes');
            }
            Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_TIME, { interval: deliveryTimeInterval });
          })}
          onGiftSwitchToggle={this.onGiftSwitchToggle}
          isGiftSwitchOn={giftDelivery}
          giftDeliveryDetails={{
            recipientAddress,
            recipientName,
            recipientEmail,
            recipientPhone,
            recipientBusinessName,
            giftMessage,
            senderAddress,
            senderName,
            senderEmail,
            senderPhone,
            senderBusinessName,
            senderDOB
          }}
          onChangeDeliveryDetailsForm={(formState) => this.setState(formState)}
          onRecipientAddressSelected={(address, deliveryValidationStatus) => {
              this.setState({ recipientAddress: address, deliveryAddress: address, deliveryValidationStatus });
              this.onSelectUserAddress(address);
            }
          }
          onSenderAddressSelected={(address) => this.setState({ senderAddress: address })}
          shipmentSelected={this.shipmentSelected}
          makeCardActive={this.state.makeCardActive}
          />

        <div className="row footer-row-mobile">
          <div className="col-md-12">
          
            {!giftDelivery &&
              <div className="text-center text-error">MATCHING CREDIT CARD AND ID MUST BE PRESENT FOR ALL DELIVERIES.</div>
            }
            <div className="footer-buttons-container">
              <a href="javascript:void(0)" className="button button-block button-dark-grey" onClick={() => this.goBack()}>Back</a>
              {/* <a href="javascript:void(0)" className="button button-block button-blue" onClick={() => this.placeOrder()}>{'Checkout'}</a> */}

            <a href="javascript:void(0)" className="button button-block button-blue" onClick={this.getPlaceOrderDetails}>Checkout</a>
              {/* <ApplePay 
                billDetails={billDetails}
                requestFrom={'phone'}
                placeOrder={this.placeOrder}
                validateDelivery={this.validateDelivery}
              /> */}
            </div>
          </div>
        </div>

      </div>
    )
  }

  renderNoProductsInCartMessage() {
    return (
      <div className="message-container">
        <div className="title">No products to review</div>
        <div className="links">
          <Link to="/">Continue Shopping</Link>
        </div>
      </div>
    )
  }

  renderUserNotLoggedInMessage() {
    return (
      <div className="message-container">
        <div className="title">You are not logged in</div>
        <div className="links">
          <Link to="/signin">Please login to continue</Link>
        </div>
      </div>
    )
  }

  renderOrderSuccessMessage() {
    const { recentOrder } = this.props;
    return (
      <div className="message-container">
        <div className="title">Your order has been placed successfully.</div>
        <div className="info-message">We'll Notify You Via Text Message and Email with more details and when the Order is On It's Way.</div>
        <div className="links">
          <Link to="/">Continue Shopping</Link>
          <Link to={`/orders/${recentOrder}`}>View Order</Link>
        </div>
      </div>
    )
  }

  editAddress(address) {
    let loc = address.loc;
    if (loc && loc[0] && loc[1]) {
      GoogleMapApi.getPlaceByLatLng(loc[1], loc[0]).then(place => {
        LocalStorage.put("edit_google_place", place);
        this.props.history.push({ pathname: '/place-picker', state: { actionMode: 'edit', addressId: address._id, apartment: address.apartment } });
      }).catch(error => alert(error));
    } else {
      alert('Something went wrong!');
    }

  }

  deleteAddress(address) {
    let { deliveryAddress } = this.state;
    this.props.dispatch(UserActions.deleteUserAddress({
      id: address._id
    }, response => {
      if (response.status) {
        let addresses = response.data.addresses;
        this.setState({
          userAddresses: addresses,
        }, () => {
          if(deliveryAddress) {
            const address = addresses.find(add => add._id === deliveryAddress._id);
            if (!address) {
              this.setState({
                deliveryAddress: address,
                deliveryValidationStatus: {},
              }, () => {
                Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_ADDRESS, { address: address });
              });
            } 
          }
          
        });
      } else {
        this.setState({
          showAlert: true,
          swalParams: {
            title: 'Failed to delete address, please try again later!',
            type: "error",
            showConfirmButton: false
          }
        });
      }
    }));
  }

  renderPaymentInfo() {

    const { isPaymentInfoEditable, selectedCard } = this.state;
    const { cards } = this.props;
    return <PaymentCards cards={cards} viewMode={isPaymentInfoEditable
      ? 'edit'
      : 'select'} onDeleteCard={() => {}} onSelectCard={(card) => this.setState({ selectedCard: card })} selectedCard={selectedCard} onAddCardRequest={this.addPaymentCard} dispatch={this.props.dispatch}/>
  }

  renderDeliveryToAddress() {
    const { userAddresses, deliveryAddress, deliveryValidationStatus,
      isDeliveryDetailsEditable } = this.state;
    //const {deliveryPlace} = this.props;
    // const deliveryAddress = deliveryPlace && deliveryPlace.formatted_address
    //   ? deliveryPlace.formatted_address
    //   : '';
    return (
      <div className="info-row">
        <div className="content-left">
          Delivery to: &nbsp;
          <span className="text-italic">{deliveryAddress
            ? deliveryAddress.apartment ? `Apartment #: ${deliveryAddress.apartment}, ${deliveryAddress.description}` : deliveryAddress.description
            : 'Not provided'}</span>
        </div>
        {isDeliveryDetailsEditable
          ? (
            <div className="edit-address-container">
              <div className="row user-addresses-container">
                {userAddresses
                  ? (userAddresses.map(address => {
                    return (
                      <div className="col-sm-6 col-md-6 col-xl-4" key={address._id}>
                        <div className={`user-address-card ${deliveryAddress && deliveryAddress._id === address._id ? 'active' : ''}`}>
                          {/* <div className="address-header"></div> */}
                          <div className="address-content" onClick={() => this.onSelectUserAddress(address)}>
                            <p className="title">Address</p>
                            <p className="content">{address.apartment ? `Apartment #: ${address.apartment}, ${address.description}` : address.description}</p>
                          </div>
                          <div className="address-footer">
                            <ul>
                              <li onClick={() => this.onSelectUserAddress(address)}>
                                <a href="javascript:void(0)" onClick={() => this.editAddress(address)}>Edit</a>
                              </li>
                              <li>
                                <a href="javascript:void(0)" onClick={() => this.deleteAddress(address)}>Delete</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )
                  }))
                  : null}
                <div className="col-sm-6 col-md-6 col-xl-4">
                  <div className="user-address-card default">
                    <div className="content" onClick={() => this.addNewAddress()}>
                      <i className="fa fa-plus-circle icon"></i>
                      <div className="title">Add New Address</div>
                    </div>
                  </div>
                </div>
                {deliveryValidationStatus && deliveryValidationStatus.status
                  && deliveryValidationStatus.time ?
                    <div className="col-sm-12">
                      <p className="text-info">{`* For this delivery address, we will need at least ${deliveryValidationStatus.timeDisplay} to deliver.`}</p>
                    </div>
                    : null
                }
              </div>
            </div>
          )
          : null}
      </div>

    )
  }

  shipmentSelected(data){
    let cart = Cart.getCartAttribute(Cart.ATTRIBUTE_CART_STORE);
    let cartItemList = cart && cart[Cart.ATTRIBUTE_CART_ITEMS]
    ? Object.values(cart[Cart.ATTRIBUTE_CART_ITEMS])
    : [];

    if (cartItemList.length == 0) {
      return;
    }
  
    let tempOrder = Orders.buildTempOrderData(cartItemList);
    tempOrder.deliveryFee = data && Number(data.amount)
    this.props.dispatch(OrdersActions.createTempOrder(tempOrder, response => {
      if (response.status) {
        let billData = Orders.calculateBill(response.data);
        this.setState({ 
          billDetails: billData,
          tempOrder: response.data,
          isReady: true,
          makeCardActive: data.object_id,
          selectedShipment: data,
        });
      } else {
        this.setState({
          showAlert: true,
          swalParams: {
            title: 'Something went wrong!',
            type: "error",
            showConfirmButton: false
          }
        })
      }
    }))
  }

  renderScheduleDelivery() {
    const { isDeliveryDetailsEditable, deliveryTime, isTimeNowSelected, deliveryValidationStatus, giftDelivery, deliverySlot, selectedShipment, shippoResult } = this.state;
    const { shippoLoading } = this.props;

    const deliveryTimeInterval = {};
    let shippoDelivery = false;
    if(deliveryValidationStatus.region === 'SHIPPO'){
      shippoDelivery = true;
    }else{
      if (isTimeNowSelected)
      deliveryTimeInterval.start = 'now';
    else if (deliverySlot) {
      deliveryTimeInterval.start = Moment(deliveryTime)
        .hour(slots[deliverySlot][0]).minute(0);
      deliveryTimeInterval.end = Moment(deliveryTime)
        .hour(slots[deliverySlot][1]).minute(0);
    }
    else {
      deliveryTimeInterval.start = Moment(deliveryTime);
      deliveryTimeInterval.end = Moment(deliveryTime).add(60, 'minutes');
    }
    }
    return isDeliveryDetailsEditable
      ? (
        <div className="info-row">
          {deliveryValidationStatus.region === 'SHIPPO' ?
            <div className={`extended-delivery${deliveryValidationStatus.region === 'SHIPPO' ? '-shippo' : ''}`}>
              {
                  shippoResult && shippoResult.length > 0 ? shippoResult.map(data => {
                  return(
                   <div className={`shippo-details ${data.object_id == this.state.makeCardActive ? 'active-selected' : ''}`} key={data.object_id} onClick={() => this.shipmentSelected(data)}> 
                      <div className={`card-shippo ${data.object_id == this.state.makeCardActive ? 'hover' : ''}`}>
                        <div className="shippo-provider-name">
                          <div className="details">Shipping provider: {data.provider}</div>
                          <div className="details">No of Estimated Days: {data.estimated_days}</div>
                          <div className="details">Amount: ${data.amount}</div>
                        </div>
                        <img className="provider-logo" src={data.provider_image_200} alt="provider_logo_missing"/>
                      </div>
                    </div>
                  )
                }) : shippoLoading ? <div style={{display:'flex'}}>Fetching Shipping Options.. <Spinner size="small" /></div>
                  : shippoResult && shippoResult.length === 0 ? <div style={{display:'flex', color: 'red'}}>No Shipping Options Available.</div>
                  : null
              } 
            </div>
          : <div className="content-left">
            Schedule Delivery {isDeliveryDetailsEditable 
              ? (
                <div className="delivery-time-options-row">
                  { (!deliveryValidationStatus.time) && <div className="option" disabled={deliveryValidationStatus && deliveryValidationStatus.time}>
                    <i className={`fa fa${isTimeNowSelected
                      ? '-dot'
                      : ''}-circle-o`} onClick={() => this.setState({
                        isTimeNowSelected: (deliveryValidationStatus && deliveryValidationStatus.time) ? false : true
                      })} />
                    Now
                  </div> }
                  <div className="option">
                    <i className={`fa fa${isTimeNowSelected
                      ? ''
                      : '-dot'}-circle-o`} onClick={() => this.setState({
                        isTimeNowSelected: false
                      })} /> {!isTimeNowSelected
                        ? (
                          <div className="date-time-picker-container">
                            <DatePicker
                              selected={deliveryTime}
                              dateFormat={giftDelivery || !deliveryValidationStatus.time ? "MM/DD/YYYY hh:mm A" : "MM/DD/YYYY"}
                              minDate={deliveryTime || Moment()}
                              dropdownMode="select"
                              showMonthDropdown
                              showYearDropdown
                              showTimeSelect={giftDelivery || !deliveryValidationStatus.time}
                              placeholderText="Custom Time"
                              onChange={value => this.setState({ deliveryTime: value, isDeliveryDetailsEdited: true }, () => {
                                const deliveryTimeInterval = {};
                                const { deliveryTime } = this.state;

                                deliveryTimeInterval.start = Moment(deliveryTime);
                                deliveryTimeInterval.end = Moment(deliveryTime).add(60, 'minutes');
                                Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_TIME, { interval: deliveryTimeInterval });
                              })}
                              readOnly={true}
                            />
                            {(!giftDelivery && Boolean(deliveryValidationStatus.time))
                              && <select defaultValue={deliverySlot} onChange={e => this.onSlotChange(e.target.value)}>
                                <option value="morning">
                                  Morning Delivery (9am to 12 noon)
                                </option>
                                <option value="afternoon" >
                                  Afternoon Delivery (12pm to 3pm)
                                </option>
                                <option value="evening" >
                                  Evening Delivery (3pm to 6pm)
                                </option>
                              </select>
                            }
                          </div>
                        )
                        : 'Custom Time'}
                  </div>
                </div>
              )
              : 'Schedule Delivery: Now'}
          </div>}
          <div className="content-right"/>
        </div>
      )
      : (
        <div className="info-row">Schedule Delivery: &nbsp;
          <span className="text-italic">{shippoDelivery ?
             selectedShipment && selectedShipment.estimated_days ? `${selectedShipment.estimated_days} DAYS` : `SELECT A SHIPPING OPTION` :
            isTimeNowSelected
            ? 'Now'
            : `${deliveryTime ? deliveryTime.format('MM-DD-YYYY') : null}, ${deliveryTimeInterval ? deliveryTimeInterval.start.format('hh:mma') : null} - ${deliveryTimeInterval ? (Moment(deliveryTimeInterval.end).format('hh:mma')) : null}`}</span>
          { deliveryValidationStatus && deliveryValidationStatus.status && deliveryValidationStatus.time ?
            <p className="text-info no-space">{`* We will need at least ${deliveryValidationStatus.timeDisplay} to deliver to this address.`}</p>
              : null }
        </div>
      );
  }

  renderDeliveryNotes() {

    const { isDeliveryDetailsEditable, deliveryNotes } = this.state;

    return isDeliveryDetailsEditable
      ? (
        <div className="info-row input-container">
          <div className="content-left">
            <input placeholder="Delivery Notes" aria-label="Delivery Notes" className="delivery-note-input" onChange={e => this.setState({ deliveryNotes: e.target.value, isDeliveryDetailsEdited: true })} value={deliveryNotes} />
          </div>
          <div className="content-right"></div>
        </div>
      )
      : (
        <div className="info-row">Delivery Notes: &nbsp;
          <span className="text-italic">{deliveryNotes
            ? deliveryNotes
            : 'Not provided'}</span>
        </div>
      );
  }

  renderBillingAddress() {

    const { isBillingAddressEditable, isCopyOfDeliveryAddress, billingAddress, deliveryAddress } = this.state;

    return isBillingAddressEditable
      ? (
        <div>
          <div className="options-container">
            <div className="option">
              <i className={`fa fa${isCopyOfDeliveryAddress
                ? '-dot'
                : ''}-circle-o`} onClick={() => this.setState({
                  isCopyOfDeliveryAddress: !isCopyOfDeliveryAddress,
                  billingAddress: deliveryAddress ? deliveryAddress.description : ''
                })} />
              <span>Same as Delivery Address</span>
            </div>
            <div className="option">
              <i className={`fa fa${!isCopyOfDeliveryAddress
                ? '-dot'
                : ''}-circle-o`} onClick={() => this.setState({
                  isCopyOfDeliveryAddress: !isCopyOfDeliveryAddress,
                  billingAddress: ''
                })} />
              <span>Custom</span>
            </div>
          </div>
          <div className="info-row">
            <textarea placeholder="Billing Address" aria-label="Billing Address" className="billing-address-input" readOnly={isCopyOfDeliveryAddress
              ? 'readonly'
              : null} onChange={(e) => this.setState({ 'billingAddress': e.target.value })} value={billingAddress}></textarea>
          </div>
        </div>
      )
      : (
        <div className="info-row">
          <span className="text-italic">{isCopyOfDeliveryAddress
            ? (deliveryAddress
              ? deliveryAddress.description
              : 'Not provided')
            : (billingAddress
              ? billingAddress
              : 'Not provided')}</span>
        </div>
      )
  }

  renderDeliveryScheduleInfo() {
    return (
      <div className="row info-schedule-container">
        <div className="info">Hours of Operations:</div>
        <div className="info">Mon – Sun: 9am to 2am</div>
        <div className="info">365 days!<br />Delivery available ALL DAY!</div>
      </div>
    )
  }

  renderGiftDeliveryDetails() {
    const { isDeliveryDetailsEditable, recipientAddress, recipientName, recipientEmail, recipientPhone, recipientBusinessName, giftMessage, senderAddress, senderName, senderEmail, senderPhone, senderBusinessName, senderDOB } = this.state;
    const { receiverAddressModal, senderAddressModal, deliveryValidationStatus } = this.state;
    return isDeliveryDetailsEditable ?
      (
        <div className="gift-delivery-details-container">
          <div className="recipient-details">
            <div className="section-title">Recipient Details</div>
            <div className="row info-row">
              <div className="col-sm-12 col-md-6 col-xl-4">
                {recipientAddress ?
                  <div className="user-address-card default">
                    <div className="address-content" onClick={this.openReceiverAddressModal}>
                      <p className="title">Recepient Address</p>
                      <div className="content">
                        <div>{recipientAddress.apartment ? `Apartment #: ${recipientAddress.apartment}` : ''}</div>
                        <div>{recipientAddress.description}</div>
                      </div>
                    </div>
                  </div>
                  :
                  <div className="user-address-card default">
                    <div className="content" onClick={this.openReceiverAddressModal}>
                      <i className="fa fa-plus-circle icon"></i>
                      <div className="title">Add RECIPIENT Address</div>
                    </div>
                  </div>
                }
              </div>

              <div className="col-sm-12 col-md-6 col-xl-8">
                <input placeholder="RECIPIENT NAME" aria-label="RECIPIENT NAME" onChange={e => this.setState({ recipientName: e.target.value, isDeliveryDetailsEdited: true })} value={recipientName} />
                <input placeholder="RECIPIENT EMAIL (OPTIONAL)" aria-label="RECIPIENT EMAIL (OPTIONAL)" onChange={e => this.setState({ recipientEmail: e.target.value, isDeliveryDetailsEdited: true })} value={recipientEmail} />
                <input placeholder="RECIPIENT PHONE" aria-label="RECIPIENT PHONE" type="number" onChange={e => this.setState({ recipientPhone: e.target.value, isDeliveryDetailsEdited: true })} value={recipientPhone} />
                <input placeholder="RECIPIENT BUSINESS NAME (OPTIONAL)" aria-label="RECIPIENT BUSINESS NAME (OPTIONAL)" onChange={e => this.setState({ recipientBusinessName: e.target.value, isDeliveryDetailsEdited: true })} value={recipientBusinessName} />
                <textarea placeholder="GIFT MESSAGE" aria-label="GIFT MESSAGE" className="gift-messsage" onChange={(e) => this.setState({ 'giftMessage': e.target.value })} value={giftMessage}></textarea>
              </div>
            </div>
            {deliveryValidationStatus && deliveryValidationStatus.status && deliveryValidationStatus.time ?

              <div className="row">
                <div className="col-sm-12">
                  <p className="text-info">{`* For this recepient address, we will need at least ${deliveryValidationStatus.timeDisplay} to deliver.`}</p>
                </div>
              </div>
              : null
            }
          </div>
          <div className="sender-details">
            <div className="section-title">Sender Details</div>
            <div className="row info-row">
              <div className="col-sm-12 col-md-6 col-xl-4">
                {senderAddress ?
                  <div className="user-address-card default">
                    <div className="address-content" onClick={this.openSenderAddressModal}>
                      <p className="title">Sender Address</p>
                      <div className="content">
                        <div>{senderAddress.apartment ? `Apartment #: ${senderAddress.apartment}` : ''}</div>
                        <div>{senderAddress.description}</div>
                      </div>
                    </div>
                  </div>
                  :
                  <div className="user-address-card default">
                    <div className="content" onClick={this.openSenderAddressModal}>
                      <i className="fa fa-plus-circle icon"></i>
                      <div className="title">Add Sender Address</div>
                      <div className="title">(OPTIONAL)</div>
                    </div>
                  </div>
                }
              </div>

              <div className="col-sm-12 col-md-6 col-xl-8">
                <input placeholder="SENDER NAME (OPTIONAL)" aria-label="SENDER NAME (OPTIONAL)" onChange={e => this.setState({ senderName: e.target.value, isDeliveryDetailsEdited: true })} value={senderName} />
                <input placeholder="SENDER EMAIL (OPTIONAL)" aria-label="SENDER EMAIL (OPTIONAL)" onChange={e => this.setState({ senderEmail: e.target.value, isDeliveryDetailsEdited: true })} value={senderEmail} />
                <input placeholder="SENDER PHONE (OPTIONAL)" aria-label="SENDER PHONE (OPTIONAL)" type="number" onChange={e => this.setState({ senderPhone: e.target.value, isDeliveryDetailsEdited: true })} value={senderPhone} />
                {recipientPhone == senderPhone ? <div className="phone-error">Recipient and sender phone numbers can't be the same. </div> : null}
                <input placeholder="SENDER BUSINESS NAME (OPTIONAL)" aria-label="SENDER BUSINESS NAME (OPTIONAL)" onChange={e => this.setState({ senderBusinessName: e.target.value, isDeliveryDetailsEdited: true })} value={senderBusinessName} />
                <DatePicker
                  selected={senderDOB}
                  dateFormat="MM/DD/YYYY"
                  dropdownMode="select"
                  maxDate={Moment().subtract(21, 'years')}
                  showMonthDropdown
                  showYearDropdown
                  placeholderText="SENDER DOB (MM/DD/YYYY)"
                  onChange={value => this.setState({ senderDOB: value, isDeliveryDetailsEdited: true })}
                />
              </div>
            </div>

          </div>
          {receiverAddressModal ?
            <SimpleModal
              onCloseRequest={this.closeReceiverAddressModal}
            >
              <PlacePicker
                onPlaceSelect={() => { }}
                onSubmit={(address, deliveryValidationStatus) => {
                    this.setState({ recipientAddress: address, deliveryAddress:address, receiverAddressModal: false, deliveryValidationStatus });
                    this.onSelectUserAddress(address);
                  }
                }
                deliveryValidation={'GIFT'}
              />
            </SimpleModal>
            : null
          }
          {senderAddressModal ?
            <SimpleModal
              onCloseRequest={this.closeSenderAddressModal}
            >
              <PlacePicker
                onPlaceSelect={() => { }}
                onSubmit={(address) => this.setState({ senderAddress: address, senderAddressModal: false })}
              />
            </SimpleModal>
            : null
          }
        </div>
      ) :
      (
        <div className="gift-delivery-details-container">
          <div className="recipient-details edited">
            <div className="section-title">GIFT DELIVERY Recipient Details</div>
            {recipientName ?
              <div className="info-row">
                <span className="text-italic">
                  {recipientName}
                </span>
              </div>
              : null
            }
            {recipientBusinessName ?
              <div className="info-row">
                <span className="text-italic">
                  {recipientBusinessName}
                </span>
              </div>
              : null
            }
            {recipientAddress ?

              <div className="info-row">
                <span className="text-italic">
                  {recipientAddress.apartment ? `Apartment #: ${recipientAddress.apartment}` : ''} &nbsp;
                {recipientAddress.description}
                </span>
              </div>
              : null
            }
            {recipientPhone ?
              <div className="info-row">
                <span className="text-italic">
                  {recipientPhone}
                </span>
              </div>
              : null
            }
            {giftMessage ?
              <div className="info-row">GIFT MESSAGE: &nbsp;
            <span className="text-italic">
                  {giftMessage}
                </span>
              </div>
              : null
            }
          </div>
          <div className="sender-details edited">
            <div className="section-title">SENDER DETAILS</div>
            {senderName ?
              <div className="info-row">
                <span className="text-italic">
                  {senderName}
                </span>
              </div>
              : null
            }
            {senderBusinessName ?
              <div className="info-row">
                <span className="text-italic">
                  {senderBusinessName}
                </span>
              </div>
              : null
            }
            {senderAddress ?
              <div className="info-row">
                <span className="text-italic">
                  {senderAddress.apartment ? `Apartment #: ${senderAddress.apartment}` : ''} &nbsp;
                  {senderAddress.description}
                </span>
              </div>
              : null
            }
            {senderEmail ?
              <div className="info-row">
                <span className="text-italic">
                  {senderEmail}
                </span>
              </div>
              : null
            }
            {senderPhone ?
              <div className="info-row">
                <span className="text-italic">
                  {senderPhone}
                </span>
              </div>
              : null
            }
            <div className="info-row">SENDER DOB: &nbsp;
            <span className="text-italic">
                {senderDOB ? Moment(senderDOB).format('L') : 'Not provided'}
              </span>
            </div>
          </div>
        </div>
      )
  }

  goBack() {
    this.props.history.goBack();
  }

  onPaymentInfoEditDone() {

    const { isPaymentInfoEditable } = this.state;

    this.setState({
      isPaymentInfoEditable: !isPaymentInfoEditable
    })

  }

  onGiftSwitchToggle() {
    const giftDelivery = this.state.giftDelivery;
    const updatedState = {
      giftDelivery: !giftDelivery,
      deliveryAddress: (undefined),
      recipientAddress: undefined,
      deliveryValidationStatus: {
        status: true,
        time: 0,
        region: "NA"
      },
      deliverySlot: '',
      selectedShipment: {},
    };
    this.setState(updatedState, () => {
      Cart.modifyCartAttribute(Cart.ATTRIBUTE_GIFT_DELIVERY, { giftDelivery: this.state.giftDelivery });
    });
  }

  openReceiverAddressModal() {
    this.setState({ receiverAddressModal: true })
  }

  closeReceiverAddressModal() {
    this.setState({ receiverAddressModal: false })
  }

  openSenderAddressModal() {
    this.setState({ senderAddressModal: true })
  }

  closeSenderAddressModal() {
    this.setState({ senderAddressModal: false })
  }
  onDeliveryDetailsEditDone() {

    const {
      isDeliveryDetailsEditable,
      isTimeNowSelected,
      deliveryAddress,
      deliveryTime,
      isDeliveryDetailsEdited,
      deliveryNotes,
      giftDelivery,
      deliverySlot,
    } = this.state;
    let newState = {};
    if (isDeliveryDetailsEditable && isDeliveryDetailsEdited && !giftDelivery) {
      let timeValidity = Orders.validateDeliveryTime(isTimeNowSelected, deliveryTime.toDate());
      newState.isDeliveryDetailsEdited = false;
      if (!timeValidity.status) {
        this.setState({
          showAlert: true,
          swalParams: {
            title: timeValidity.message,
            type: "warning",
            showConfirmButton: false
          }
        });
        // setTimeout(() => this.setState({showAlert: false}), 2000);
        newState.isTimeNowSelected = true;
        newState.deliveryTime = Moment();
      }

      let deliveryTimeInterval = {}
      if (isTimeNowSelected)
        deliveryTimeInterval.start = 'now';
      else if (deliverySlot) {
        deliveryTimeInterval.start = Moment(deliveryTime)
          .hour(slots[deliverySlot][0]).minute(0);
        deliveryTimeInterval.end = Moment(deliveryTime)
          .hour(slots[deliverySlot][1]).minute(0);
      }
      else {
        deliveryTimeInterval.start = Moment(deliveryTime).toDate();
        deliveryTimeInterval.end = Moment(deliveryTime).add(60, 'minutes').toDate();
      }
      Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_ADDRESS, { address: deliveryAddress });
      Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_TIME, { interval: deliveryTimeInterval })
      Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_NOTES, { notes: deliveryNotes });

    } else if (isDeliveryDetailsEditable && giftDelivery) {
      if (this.validateGiftDeliveryDetails()) {
        return;
      } else {
        this.setCartGiftDeliveryDetails()
        newState.deliveryAddress = this.state.recipientAddress
      }
    }

    newState.isDeliveryDetailsEditable = !isDeliveryDetailsEditable;
    this.setState(newState);
  }

  setCartGiftDeliveryDetails() {
    const { recipientName, recipientAddress, recipientBusinessName, recipientEmail, recipientPhone, giftMessage,
      senderName, senderEmail, senderPhone, senderBusinessName, senderDOB, senderAddress,
      deliveryValidationStatus, isTimeNowSelected, giftDelivery, deliveryNotes, deliveryTime } = this.state;

    let deliveryTimeInterval = {}
    if (isTimeNowSelected)
      deliveryTimeInterval.start = 'now';
    else {
      deliveryTimeInterval.start = deliveryTime.toDate();
      deliveryTimeInterval.end = Moment(deliveryTime).add(60, 'minutes').toDate();
    }
    Cart.modifyCartAttribute(Cart.ATTRIBUTE_GIFT_DELIVERY_DETAILS, {
      giftDeliveryDetails: {
        recipientName,
        recipientAddress,
        recipientBusinessName,
        recipientEmail,
        recipientPhone,
        giftMessage,
        senderName,
        senderEmail,
        senderPhone,
        senderBusinessName,
        senderDOB,
        senderAddress,
        deliveryValidationStatus
      }
    });
    Cart.modifyCartAttribute(Cart.ATTRIBUTE_GIFT_DELIVERY, { giftDelivery });
    Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_ADDRESS, { address: recipientAddress });
    Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_TIME, { interval: deliveryTimeInterval })
    Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_NOTES, { notes: deliveryNotes });
  }

  validateGiftDeliveryDetails() {
    const { recipientAddress, recipientName, recipientPhone, recipientEmail, deliveryTime, deliveryValidationStatus } = this.state;
    const { senderDOB, senderPhone, senderEmail } = this.state;
    let error = [];
    if (!recipientAddress) {
      error.push('Please select a recipeint address.');
    }
    if (recipientPhone == senderPhone) {
      error.push("Recipient and Sender phone numbers can't be the same.");
    }
    if (!recipientName) {
      error.push('Please enter a recipient name.');
    }
    if (!recipientPhone || !Utils.isPhoneNumberValid(recipientPhone)) {
      error.push('Please enter a valid receipient Phone number.');
    }
    if (recipientEmail && !Utils.isEmailValid(recipientEmail)) {
      error.push('Please enter a valid receipient email address.');
    }
    if (senderPhone && !Utils.isPhoneNumberValid(senderPhone)) {
      error.push('Please enter a valid sender Phone number.');
    }
    if (senderEmail && !Utils.isEmailValid(senderEmail)) {
      error.push('Please enter a valid sender email address.');
    }
    if (senderDOB && (!(Moment().diff(Moment(senderDOB), 'years', false) >= 21))) {
      error.push('Please enter a valid sender Date of Birth. The sender must be 21 years old.');
    }
    if (recipientAddress && (!deliveryTime || !(Moment(deliveryTime).diff(Moment(), 'hours', false) >= deliveryValidationStatus.time))) {
      error.push(`Please re-schedule your delivery time.  For the selected recipient address, we will need at least ${deliveryValidationStatus.timeDisplay} to deliver.`);
    }
    if (error.length > 0) {
      this.setState({
        showAlert: true,
        swalParams: {
          title: "Validation Error",
          text: error.join('\n'),
          type: "warning"
        }
      })
      return true;
    }
    return false;
  }
  onBillingAddressEditDone() {

    const { isBillingAddressEditable, billingAddress, isCopyOfDeliveryAddress } = this.state;

    if (isBillingAddressEditable) {
      Cart.modifyCartAttribute(Cart.ATTRIBUTE_BILLING_ADDRESS, { address: billingAddress });
      Cart.modifyCartAttribute(Cart.ATTRIBUTE_IS_SAME_AS_DELIVERY_ADDRESS, { value: isCopyOfDeliveryAddress });
    }
    this.setState({
      isBillingAddressEditable: !isBillingAddressEditable
    })
  }

  // callStripe(STRIPE_PUBLIC_KEY){
  //   return loadStripe(STRIPE_PUBLIC_KEY)
  // }

  validateDeliveryForCheckoutSession() {
    let err = false;
    const {
      cartItems,
      isTimeNowSelected,
      billDetails,
      selectedCard,
      deliveryAddress,
      giftDelivery,
      deliveryTime,
      deliveryValidationStatus,
      selectedShipment,userDob
    } = this.state;
    if (giftDelivery && this.validateGiftDeliveryDetails()) {
      err = true;
      return err;
    }
    const shippoDelivery = deliveryValidationStatus.region === 'SHIPPO';

    let error = [];
    if (!deliveryAddress)
      error.push('Please select delivery address');
    if (!isTimeNowSelected && !deliveryTime)
      error.push('Please select delivery time');
    
    let dobValidity = Orders.validateUserDOB(userDob);
    
    if (!dobValidity.status)
      error.push(dobValidity.message);
      
    let timeValidity = Orders.validateDeliveryTime(isTimeNowSelected, deliveryTime.toDate());
    if (!timeValidity.status)
      error.push(timeValidity.message);

    if (error.length > 0) {
      this.setState({
        showAlert: true, swalParams: {
          title: "Validation Error",
          text: error.join('\n'),
          type: "warning"
        }
      });
      err = true;
    } else {
        if (billDetails.total < 8.5) {
          this.setState({
            showAlert: true, swalParams: {
              title: 'Sorry you must spend at least $8.50 for delivery',
              type: "warning",
              showConfirmButton: false
            }
          });
          err = true;
        } else {


          if (shippoDelivery && (!selectedShipment || !selectedShipment.object_id)) {
            this.setState({
              showAlert: true, swalParams: {
                title: "Please select a shipping option.",
                type: "error",
                showConfirmButton: false
              }
            });
            err = true;
            return err;
          }

          let tempOrder = Utils.toJS(fromJS(this.state.tempOrder));
          if (!tempOrder) {
            this.setState({
              showAlert: true, swalParams: {
                title: "Something went wrong!",
                type: "error",
                showConfirmButton: false
              }
            });
            err = true;
          }
        }
      
    }
    return err;
  }
  validateDelivery(applePay) {
    let err = false;
    const {
      cartItems,
      isTimeNowSelected,
      billDetails,
      selectedCard,
      deliveryAddress,
      giftDelivery,
      deliveryTime,
      deliveryValidationStatus,
      selectedShipment,userDob
    } = this.state;
    if (giftDelivery && this.validateGiftDeliveryDetails()) {
      err = true;
      return err;
    }
    const shippoDelivery = deliveryValidationStatus.region === 'SHIPPO';

    let error = [];
    if (!selectedCard && !applePay)
      error.push('Please select payment method');
    if (!deliveryAddress)
      error.push('Please select delivery address');
    if (!isTimeNowSelected && !deliveryTime)
      error.push('Please select delivery time');
    
    let dobValidity = Orders.validateUserDOB(userDob);
    
    if (!dobValidity.status)
      error.push(dobValidity.message);
      
    let timeValidity = Orders.validateDeliveryTime(isTimeNowSelected, deliveryTime.toDate());
    if (!timeValidity.status)
      error.push(timeValidity.message);

    if (error.length > 0) {
      this.setState({
        showAlert: true, swalParams: {
          title: "Validation Error",
          text: error.join('\n'),
          type: "warning"
        }
      });
      err = true;
    } else {
        if (billDetails.total < 8.5) {
          this.setState({
            showAlert: true, swalParams: {
              title: 'Sorry you must spend at least $8.50 for delivery',
              type: "warning",
              showConfirmButton: false
            }
          });
          err = true;
        } else {


          if (shippoDelivery && (!selectedShipment || !selectedShipment.object_id)) {
            this.setState({
              showAlert: true, swalParams: {
                title: "Please select a shipping option.",
                type: "error",
                showConfirmButton: false
              }
            });
            err = true;
            return err;
          }

          let tempOrder = Utils.toJS(fromJS(this.state.tempOrder));
          if (!tempOrder) {
            this.setState({
              showAlert: true, swalParams: {
                title: "Something went wrong!",
                type: "error",
                showConfirmButton: false
              }
            });
            err = true;
          }
        }
      
    }
    return err;
  }



  async getPlaceOrderDetails() {
    const {
      isTimeNowSelected,
      deliveryNotes,
      tipPercentage,
      selectedCard,
      deliveryAddress,
      billingAddress,
      giftDelivery,
      deliverySlot,
      deliveryTime,
      recipientName,
      recipientAddress,
      recipientBusinessName,
      recipientEmail,
      recipientPhone,
      giftMessage,
      senderName,
      senderEmail,
      senderPhone,
      senderBusinessName,
      senderDOB,
      senderAddress,
      deliveryValidationStatus,
      selectedShipment,
    } = this.state;
    
    const giftDeliveryDetails = {
      recipientName,
      recipientAddress,
      recipientBusinessName,
      recipientEmail,
      recipientPhone,
      giftMessage,
      senderName,
      senderEmail,
      senderPhone,
      senderBusinessName,
      senderDOB,
      senderAddress,
      deliveryValidationStatus
    };
    const {user}=this.props;
     const shippoDelivery = deliveryValidationStatus.region === "SHIPPO";
     const deliveryDate = Moment(deliveryTime).toDate();
     let tempOrder = Utils.toJS(fromJS(this.state.tempOrder));

    //  this.validateDeliveryForCheckoutSession(applePay)
     let that = this;
     if(!this.validateDeliveryForCheckoutSession()){
        let deliveryTimeInterval = {};
        if (isTimeNowSelected) deliveryTimeInterval.start = "now";
        else if (deliverySlot) {
          deliveryTimeInterval.start = Moment(deliveryTime)
            .hour(slots[deliverySlot][0])
            .minute(0);
          deliveryTimeInterval.end = Moment(deliveryTime)
            .hour(slots[deliverySlot][1])
            .minute(0);
        } else {
          deliveryTimeInterval.start = deliveryTime.toDate();
          deliveryTimeInterval.end = Moment(deliveryTime)
            .add(60, "minutes")
            .toDate();
        }
        Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_DATE, {
          date: Moment(deliveryTime).toDate()
        });
        Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_TIME, {
          interval: deliveryTimeInterval
        });
        if (
          selectedShipment &&
          selectedShipment.object_id &&
          selectedShipment.object_id.length > 0
        ) {
          tempOrder.selectedShippingObject = selectedShipment.object_id;
        }
        // tempOrder.creditCard = applePay ? '' : selectedCard.id;
        tempOrder.walletMethod = '';
        tempOrder.owner = user._id;
        tempOrder.deliveryNote = deliveryNotes;
        tempOrder.deliverySlot = deliverySlot;
        tempOrder.address = deliveryAddress;
        tempOrder.tipPercentage = tipPercentage ? tipPercentage : 0;
        tempOrder.shippoOrder = shippoDelivery ? true : false;
        tempOrder.shippoFees = shippoDelivery
          ? Number(selectedShipment.amount)
          : 0;
        tempOrder.deliveryFee = shippoDelivery
          ? Number(selectedShipment.amount)
          : 5.99;

        tempOrder.billingAddress = {
          description: billingAddress
        };

        tempOrder.deliveryStartTime = deliveryTimeInterval.start;
        tempOrder.deliveryEndTime = deliveryTimeInterval.end;
        tempOrder.deliverNow = isTimeNowSelected;
        tempOrder.deliveryDate = deliveryDate
          ? Moment(deliveryDate)
              .format("MM/DD/YY")
              .toString()
          : null;
        tempOrder.strDeliveryStartTime = isTimeNowSelected
          ? Moment()
              .tz("America/Los_Angeles")
              .format("HH:mm")
          : deliveryTimeInterval
          ? Moment(deliveryTimeInterval.start)
              .format("HH:mm")
              .toString()
          : null;
        tempOrder.strDeliveryEndTime = isTimeNowSelected
          ? Moment()
              .tz("America/Los_Angeles")
              .add(60, "minutes")
              .format("HH:mm")
          : deliveryTimeInterval
          ? Moment(deliveryTimeInterval.end)
              .format("HH:mm")
              .toString()
          : null;
        tempOrder.deliveryDateObj = Moment(deliveryDate).toDate();
        tempOrder.giftDelivery = giftDelivery;
        tempOrder.giftDeliveryDetails = giftDeliveryDetails;
        
        this.onStripeCheckoutSubmit(tempOrder)
     }
          
    
  }
  async onStripeCheckoutSubmit(tempOrder) {
    
    let order=tempOrder;
    console.log("sdfsdcdsfvdsfv",order);
   this. props.dispatch(
      PaymentsActions.setUpStripeCheckout(order,async (response) => {
        console.log("stripe setupCheckout",order);
        if (response.status) {
          // this.setState({})
          window.location.replace(response.data.session_url)
          // console.log("stripe checkout response",response)
          // setPaymentLoading(false);
        
        } else {
          console.log("stripe checkout error")
          // setPaymentLoading(false);
           this.setState({
                  showAlert: true,
                  swalParams: {
                  title: "Something went wrong",
                  type: "error",
                  showConfirmButton: false
                  }
                });
        }
      })
    );
  }
  async placeOrder(applePay,ev) {
    const {
      isTimeNowSelected,
      deliveryNotes,
      tipPercentage,
      selectedCard,
      deliveryAddress,
      billingAddress,
      giftDelivery,
      deliverySlot,
      deliveryTime,
      recipientName,
      recipientAddress,
      recipientBusinessName,
      recipientEmail,
      recipientPhone,
      giftMessage,
      senderName,
      senderEmail,
      senderPhone,
      senderBusinessName,
      senderDOB,
      senderAddress,
      deliveryValidationStatus,
      selectedShipment,
    } = this.state;
    
    const giftDeliveryDetails = {
      recipientName,
      recipientAddress,
      recipientBusinessName,
      recipientEmail,
      recipientPhone,
      giftMessage,
      senderName,
      senderEmail,
      senderPhone,
      senderBusinessName,
      senderDOB,
      senderAddress,
      deliveryValidationStatus
    };
     const shippoDelivery = deliveryValidationStatus.region === "SHIPPO";
     const deliveryDate = Moment(deliveryTime).toDate();
     let tempOrder = Utils.toJS(fromJS(this.state.tempOrder));
     let that = this;
     if(!applePay && this.validateDelivery(applePay)) {
       return;
     } else {
        let deliveryTimeInterval = {};
        if (isTimeNowSelected) deliveryTimeInterval.start = "now";
        else if (deliverySlot) {
          deliveryTimeInterval.start = Moment(deliveryTime)
            .hour(slots[deliverySlot][0])
            .minute(0);
          deliveryTimeInterval.end = Moment(deliveryTime)
            .hour(slots[deliverySlot][1])
            .minute(0);
        } else {
          deliveryTimeInterval.start = deliveryTime.toDate();
          deliveryTimeInterval.end = Moment(deliveryTime)
            .add(60, "minutes")
            .toDate();
        }
        Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_DATE, {
          date: Moment(deliveryTime).toDate()
        });
        Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_TIME, {
          interval: deliveryTimeInterval
        });
        if (
          selectedShipment &&
          selectedShipment.object_id &&
          selectedShipment.object_id.length > 0
        ) {
          tempOrder.selectedShippingObject = selectedShipment.object_id;
        }
        // tempOrder.creditCard = applePay ? '' : selectedCard.id;
        tempOrder.walletMethod = applePay ? "apple_pay" : '';
        tempOrder.stripeID = applePay ? "" : selectedCard.customer;
        tempOrder.deliveryNote = deliveryNotes;
        tempOrder.deliverySlot = deliverySlot;
        tempOrder.address = deliveryAddress;
        tempOrder.tipPercentage = tipPercentage ? tipPercentage : 0;
        tempOrder.shippoOrder = shippoDelivery ? true : false;
        tempOrder.shippoFees = shippoDelivery
          ? Number(selectedShipment.amount)
          : 0;
        tempOrder.deliveryFee = shippoDelivery
          ? Number(selectedShipment.amount)
          : 5.99;

        tempOrder.billingAddress = {
          description: billingAddress
        };

        tempOrder.deliveryStartTime = deliveryTimeInterval.start;
        tempOrder.deliveryEndTime = deliveryTimeInterval.end;
        tempOrder.deliverNow = isTimeNowSelected;
        tempOrder.deliveryDate = deliveryDate
          ? Moment(deliveryDate)
              .format("MM/DD/YY")
              .toString()
          : null;
        tempOrder.strDeliveryStartTime = isTimeNowSelected
          ? Moment()
              .tz("America/Los_Angeles")
              .format("HH:mm")
          : deliveryTimeInterval
          ? Moment(deliveryTimeInterval.start)
              .format("HH:mm")
              .toString()
          : null;
        tempOrder.strDeliveryEndTime = isTimeNowSelected
          ? Moment()
              .tz("America/Los_Angeles")
              .add(60, "minutes")
              .format("HH:mm")
          : deliveryTimeInterval
          ? Moment(deliveryTimeInterval.end)
              .format("HH:mm")
              .toString()
          : null;
        tempOrder.deliveryDateObj = Moment(deliveryDate).toDate();
        tempOrder.giftDelivery = giftDelivery;
        tempOrder.giftDeliveryDetails = giftDeliveryDetails;
        console.log("ORDER_PAYLOAD", tempOrder);
        
        if (applePay) {
          that.props.dispatch(
            OrdersActions.placeOrder(tempOrder, response =>
              placeOrderResponse(response, ev)
            )
          );
        } else {
          that.props.dispatch(
            OrdersActions.placeOrder(tempOrder, response =>
              placeOrderResponse(response)
            )
          );
        }
     }
          
    function placeOrderResponse(response, ev){
      if (response.status) {
        that.props.dispatch(PaymentsActions.requestConfirmation());
        if(ev) { // Apple Pay's case. 
          that.state.stripe.confirmCardPayment(response.data.clientSecret, {
            payment_method: ev.paymentMethod.id,
          },
          { handleActions: false }
          ).then((result) => { 
            if (result.error) {
              that.props.dispatch(PaymentsActions.finishConfirmation()); 
              if (response.data && response.data.orderId) {
                /* if an error occurred while confirmPayment but an order was created, we send the user to the order details page
                  so that he/she can change the paymentMethod there and try again for the same order id. for ApplePay's case, we need 
                  to close the browser payment method collection interface before redirecting the user to the order details page. So,
                  we need to call ev.complete("success").
                */
                ev.complete("success");
                Cart.clearCart();
                that.props.history.push({
                  pathname: `orders/${response.data.orderId}`,
                  state: {
                    mode: "paymentError",
                    paymentError: result.error
                  }
                });
              } else {
                /* Report to the browser that the payment failed, prompting it to
                  re-show the payment interface, or show an error message and close
                  the payment interface. The order isn't created yet from the backend. So, the user can still play around with the order details
                  and change the payment method on the checkout page itself.
                */
                ev.complete("fail");
                that.setState({
                  showAlert: true,
                  swalParams: {
                  title: result.error
                    ? result.error.message
                    : "Something went wrong with your payment method. Please try using a different Payment Method.",
                  type: "error",
                  showConfirmButton: false
                  }
                });
              }
            } else {
              // Report to the browser that the confirmation was successful, prompting
              // it to close the browser payment method collection interface.
              ev.complete("success");
              let paymentIntent = result.paymentIntent;
              // Check if the PaymentIntent requires any actions and if so let Stripe.js
              // handle the flow as we do not pass in handleActions: false in this case so that stripe handles next actions itself.
              // If using an API version older than "2019-02-11" 
              // instead check for: `paymentIntent.status === "requires_source_action"`.
              if (paymentIntent.status === "requires_action" || paymentIntent.status === "requires_source_action") {
                that.state.stripe
                  .confirmCardPayment(response.data.clientSecret)
                  .then(confirm => {
                    if (confirm.error) {
                      that.props.dispatch(PaymentsActions.finishConfirmation()); 
                      if (response.data && response.data.orderId) {
                        /* if an error occurred while confirmPayment but an order was created, we send the user to the order details page
                          so that he/she can change the paymentMethod there and try again for the same order id. The browser payment interface
                          would already be closed as we called ev.complete("success") above.
                        */
                        Cart.clearCart();
                        that.props.history.push({
                          pathname: `orders/${response.data.orderId}`,
                          state: {
                            mode: "paymentError",
                            paymentError: confirm.error
                          }
                        });
                      } else {
                        /* The order isn't created yet from the backend. So, the user can still play around with the order details
                          and change the payment method on the checkout page itself. Payment Interface would be closed in this case as 
                          we already called ev.complete("success") above and the user can change the payment method or click on Apple Pay 
                          again if he/she intends to pay via Apple Pay. 
                        */
                        that.setState({
                          showAlert: true,
                          swalParams: {
                          title: confirm.error
                            ? confirm.error.message
                            : "Something went wrong with your payment method. Please try using a different Payment Method.",
                          type: "error",
                          showConfirmButton: false
                          }
                        });
                      }
                    } else {
                        that.props.dispatch(PaymentsActions.finishConfirmation()); 
                        Cart.clearCart();
                        that.setState({ placeOrderSuccess: true });
                        window.scrollTo(0, 0);
                    }
                  });
              } else {
                  that.props.dispatch(PaymentsActions.finishConfirmation()); 
                  Cart.clearCart();
                  that.setState({ placeOrderSuccess: true });
                  window.scrollTo(0, 0);
              }
            }
          }).catch((err) => {
            console.log(err,"error occurred")
          })
        } else {
          that.state.stripe
            .confirmCardPayment(response.data.clientSecret, {
              payment_method: that.state.selectedCard.id
            })
            .then(function(result) {
              that.props.dispatch(PaymentsActions.finishConfirmation());
              if (result.error) {
                if (response.data && response.data.orderId) {
                  Cart.clearCart();
                  that.props.history.push({
                    pathname: `orders/${response.data.orderId}`,
                    state: {
                      mode: "paymentError",
                      paymentError: result.error
                    }
                  });
                } else {
                  that.setState({
                    showAlert: true,
                    swalParams: {
                      title: result.error
                        ? result.error.message
                        : "Something went wrong with your payment method. Please try using a different Payment Method.",
                      type: "error",
                      showConfirmButton: false
                    }
                  });
                }
              } else {
                Cart.clearCart();
                that.setState({ placeOrderSuccess: true });
                window.scrollTo(0, 0);
              }
            });
        }    
      } else {
        that.setState({
          showAlert: true, swalParams: {
            title: (response && response.data && response.data.error) ?
              response.data.error.message :
              "Failed to process your order, please try again later!",
            type: "error",
            showConfirmButton: false
          }
        });
      }
    }
  }

  deleteProduct(productId) {

    if (confirm('Are you want to remove this product?')) {
      Cart.removeCartAttribute(Cart.ATTRIBUTE_CART_ITEM, { itemId: productId });
      setTimeout(() => {
        let cartItems = Cart.getCartAttribute(Cart.ATTRIBUTE_CART_ITEMS);
        this.setState({ cartItems });
      }, 400)
    }

  }

  addPaymentCard() {
    this.setState({ isPaymentInfoEditable: false });
  }


  onChangeProductQuantity(product, newQuantity) {

    const { cartItems } = this.state;

    if (product.quantity == 1 & newQuantity == 1) {
      this.deleteProduct(product._id)
    } else {
      let isRecommendedProduct = Utils.isRecommendedProduct(product);
      if (!isRecommendedProduct && (product['Qty'] < newQuantity)) {
        this.setState({
          showAlert: true,
          swalParams: {
            title: 'We are in the process of restocking this item!',
            type: "error",
            showConfirmButton: false
          }
        })
        return;
      }

      let copyOfItems = fromJS(cartItems).toJS();
      copyOfItems[product._id].quantity = newQuantity;
      this.setState({ cartItems: copyOfItems })

      Cart.modifyCartAttribute(Cart.ATTRIBUTE_CART_ITEM, {
        id: product._id,
        details: copyOfItems[product._id]
      });
    }

  }

  addressUpdated(e) {
    let cart = e.detail;
    let IsAddressOutside = this.IsAddressOutside();
    const cartItemList = cart && cart[Cart.ATTRIBUTE_CART_ITEMS]
      ? Object.values(cart[Cart.ATTRIBUTE_CART_ITEMS])
      : [];
    if (cartItemList.length > 0) {
      let newPriced = this.transformCartItemPriceBasedBasedOnAddress(cartItemList, IsAddressOutside);
      this.setPriceUpdate(cart[Cart.ATTRIBUTE_CART_ITEMS], newPriced);
    }
    // this.loadCart();
    // this.setState({
    //   cartItems: cartItemList});
  }

  IsAddressOutside() {
    let storedAddressValidation = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_VALIDATION_STATUS);
    let IsAddressOutside = storedAddressValidation && storedAddressValidation.region == 'SHIPPO';
    return IsAddressOutside
  }

  transformCartItemPriceBasedBasedOnAddress(cartItems, isOutside) {
    let copyOfItems = fromJS(cartItems).toJS();
     if (isOutside) {
      copyOfItems.forEach(obj => {
        obj.PriceB = obj.Suggested;
      });
      return copyOfItems;
    } else {
      copyOfItems.forEach(obj => {
        obj.PriceB = Number(obj.Price);
      });
      return copyOfItems;
    }

  }
  setPriceUpdate(cartObj, updatedCartItemArr) {
    Object.keys(cartObj).forEach((key, index) => {
      cartObj[key] = updatedCartItemArr[index]
    });
    Cart.modifyCartAttribute(Cart.ATTRIBUTE_CART_ITEMS, {
      items: cartObj
    })
  }
  updateCart(e) {
    // eslint-disable-next-line no-useless-escape
    let page = this.props.history.location.pathname.replace("\/", "");
    if (page === 'review-order')
      this.doOnCartChanged(e.detail)

  }

  doOnCartChanged(cart) {

    let cartItemList = cart && cart[Cart.ATTRIBUTE_CART_ITEMS]
      ? Object.values(cart[Cart.ATTRIBUTE_CART_ITEMS])
      : [];

    if (cartItemList.length == 0) {
      return;
    }

    let tempOrder = Orders.buildTempOrderData(cartItemList)
    this.props.dispatch(OrdersActions.createTempOrder(tempOrder, response => {
      if (response.status) {
        let billData = Orders.calculateBill(response.data);
        this.setState({ billDetails: billData, tempOrder: response.data, isReady: true })
      } else {
        this.setState({
          showAlert: true,
          swalParams: {
            title: 'Something went wrong!',
            type: "error",
            showConfirmButton: false
          }
        })
      }
    }))
    const deliveryValidationStatus = this.state.deliveryValidationStatus;
    if (deliveryValidationStatus && deliveryValidationStatus.region === "SHIPPO") {
      this.resetShippingState();
      const address = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_ADDRESS);
      this.calculateShipping(address);
    }
  }

  addNewAddress() {
    this.props.history.push({
      pathname: '/place-picker',
      state: {
        actionMode: 'add'
      }
    });
  }

  resetShippingState() {
    this.setState({
      selectedShipment: {},
      shippoResult: [],
    });
  }

  calculateShipping(address) {
    let cartItems = Cart.getCartAttribute(Cart.ATTRIBUTE_CART_ITEMS);
    let bottleQuantityArray = [];
    let products = [];
    for (let [key, value] of Object.entries(cartItems)) {
      bottleQuantityArray.push(value.quantity);
      products.push({ id: key, quantity: value.quantity});
    }

    let noOfBottles = bottleQuantityArray.reduce((a,b) => a + b, 0);
    let data = {};
    data = {
      noOfBottles: noOfBottles,
      products: products,
      addressTo: {
        name: this.state.userName,
        street1: address.street,
        city: address.city,
        state: address.state,
        zip: address.zip,
        country: address.country,
        phone: this.state.userPhone,
        email: this.state.userEmail,
      },
    };
    this.props.dispatch(
      OrdersActions.shipporShipment(data, (response) => {
        if (response && response.status) {
          this.setState({ shippoResult: response.data && response.data.rates ?  response.data.rates : []});
        }
      })
    );
  }
  onSelectUserAddress(address) {
    const { billingAddress, isCopyOfDeliveryAddress, deliverySlot, deliveryTime } = this.state;
    const deliveryValidationStatus = validateLatLongForDelivery({
      lat: address.loc[1],
      lng: address.loc[0],
    }, 'GIFT');
    // same day delivery - no need to validate time
    // others - minimum 2 days or 48 hours
    const validTime = deliveryValidationStatus.time < 12 ? 0 : 48;
    const deliveryTimeInterval = {};
    const isTimeNowSelected = validTime === 0 ? true : false;
    this.resetShippingState();
    if (deliveryValidationStatus.region === "SHIPPO") {
      // this.calculateShipping(address); No need to call calcShipping here as it will be called once the address is set in the cart object via doOnCartChanged.
    } else {
      if (isTimeNowSelected) deliveryTimeInterval.start = "now";
      else if (deliverySlot) {
        deliveryTimeInterval.start = Moment(deliveryTime)
          .hour(slots[deliverySlot][0])
          .minute(0);
        deliveryTimeInterval.end = Moment(deliveryTime)
          .hour(slots[deliverySlot][1])
          .minute(0);
      } else {
        deliveryTimeInterval.start = Moment().add(validTime, "hours").toDate();
        deliveryTimeInterval.end = Moment()
          .add(validTime, "hours")
          .add(60, "minutes")
          .toDate();
      }
    }
   
    this.setState({
      deliveryAddress: address,
      billingAddress: isCopyOfDeliveryAddress ? address.description : billingAddress,
      deliveryValidationStatus: {
        ...deliveryValidationStatus,

        // same day delivery - no need to validate time
        time: validTime,
        // only used for normal deliveries in extended areas
        // intentionally changed to 2 business days
        // read JSDoc - validateLatLongForDelivery
        timeDisplay: deliveryValidationStatus.time < 12 ? '' : '2 days'
      },
      deliverySlot: deliveryValidationStatus.time < 12 ? '' : 'morning',
      isTimeNowSelected,

      // + 1 - edge case for better UX
      // validation will always fail since the diff might
      // be 47 hours 59 minutes at the time of validation
      deliveryTime: Moment().add(validTime + 1, 'hours'),
    }, () => {
      Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_ADDRESS, { address: address });
      Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_TIME, { interval: deliveryTimeInterval });
    });
  }

  restoreStoredAddresses() {

    const { userAddresses, isCopyOfDeliveryAddress, giftDelivery, recipientAddress } = this.state;
    let storedAddress = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_ADDRESS);
    let storedBillingAddress = Cart.getCartAttribute(Cart.ATTRIBUTE_BILLING_ADDRESS);

    let addresses = storedAddress ? userAddresses.filter(address => address._id === storedAddress._id) : undefined;
    let deliveryAddress = addresses && addresses.length == 1 ? addresses[0] : giftDelivery? recipientAddress: false;
    this.setState({
      deliveryAddress: deliveryAddress,
      billingAddress: isCopyOfDeliveryAddress
        ? (deliveryAddress
          ? deliveryAddress.description
          : '')
        : storedBillingAddress
    });

  }

  // reviewOrderAndProceed() {
  //   const {
  //     cartItems,
  //     selectedCard,
  //     deliveryTime,
  //     isTimeNowSelected,
  //     deliveryNotes,
  //     deliveryAddress,
  //     billingAddress,
  //     isCopyOfDeliveryAddress,
  //     billDetails,
  //     giftDelivery,
  //     deliveryValidationStatus,
  //     deliverySlot,
  //   } = this.state;

  //   if(giftDelivery && !this.validateGiftDeliveryDetails()) {
  //     return;
  //   }

  //   let error = [];
  //   if (!selectedCard)
  //     error.push('Please select payment method');
  //   if (!deliveryAddress)
  //     error.push('Please select delivery address');
  //   if (!isTimeNowSelected && !deliveryTime)
  //     error.push('Please select delivery time');
  //   if ((!deliveryTime || !(Moment(deliveryTime).diff(Moment(), 'hours', false) >= deliveryValidationStatus.time))) {
  //     error.push(`Please re-schedule your delivery time.  For the selected recipient address, we will need at least ${deliveryValidationStatus.timeDisplay} to deliver.`);
  //   }

  //   let timeValidity = Orders.validateDeliveryTime(isTimeNowSelected, deliveryTime.toDate());
  //   if (!timeValidity.status)
  //     error.push(timeValidity.message);

  //   if (error.length > 0) {
  //     this.setState({
  //       showAlert: true,
  //       swalParams: {
  //         title: "Validation Error",
  //         text: error.join('\n'),
  //         type: "warning"
  //       }
  //     })
  //   } else if (!billDetails) {
  //     this.setState({
  //       showAlert: true,
  //       swalParams: {
  //         title: "Something went wrong!",
  //         type: "error",
  //         showConfirmButton: false
  //       }
  //     })
  //     return;
  //   } else {

  //     let alcoholQty = 0;
  //     Object.values(cartItems).map(item => {
  //       var department = item.Department;
  //       if (this.alcoholCategories.indexOf(department) < 0) {
  //         alcoholQty += 0;
  //       } else {
  //         alcoholQty += 1;
  //       }
  //     })

  //     if (alcoholQty < 1) {
  //       this.setState({
  //         showAlert: true,
  //         swalParams: {
  //           title: 'Sorry you must have at least 1 item of alcohol for delivery',
  //           type: "warning",
  //           showConfirmButton: false
  //         }
  //       })
  //     } else {

  //       if (billDetails.total < 8.5) {
  //         this.setState({
  //           showAlert: true,
  //           swalParams: {
  //             title: 'Sorry you must spend at least $8.50 for delivery',
  //             type: "warning",
  //             showConfirmButton: false
  //           }
  //         })
  //       } else {
  //         Cart.modifyCartAttribute(Cart.ATTRIBUTE_PAYMENT_METHOD_ID, { paymentMethodId: selectedCard.id });
  //         Cart.modifyCartAttribute(Cart.ATTRIBUTE_IS_SAME_AS_DELIVERY_ADDRESS, { value: isCopyOfDeliveryAddress });
  //         Cart.modifyCartAttribute(Cart.ATTRIBUTE_BILLING_ADDRESS, { address: billingAddress });

  //         let deliveryTimeInterval = {}
  //         if (isTimeNowSelected)
  //           deliveryTimeInterval.start = 'now';
  //         else if (deliverySlot) {
  //           deliveryTimeInterval.start = Moment(deliveryTime)
  //             .hour(slots[deliverySlot][0]).minute(0);
  //           deliveryTimeInterval.end = Moment(deliveryTime)
  //             .hour(slots[deliverySlot][1]).minute(0);
  //         }
  //         else {
  //           deliveryTimeInterval.start = deliveryTime.toDate();
  //           deliveryTimeInterval.end = Moment(deliveryTime).add(30, 'minutes').toDate();
  //         }
  //         Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_DATE, { date: Moment(deliveryTime).toDate() });
  //         Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_TIME, { interval: deliveryTimeInterval })
  //         if (deliveryNotes)
  //           Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_NOTES, { notes: deliveryNotes });
  //           Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_SLOT, { deliverySlot });
  //         if(giftDelivery) {
  //           this.setCartGiftDeliveryDetails()
  //         }

  //         // this.props.history.push('/place-order');
  //       }
  //     }
  //   }
  // }

}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 992
});

export default withSizes(mapSizesToProps)(connect((state) => {
  return {
    deliveryPlace: state.getIn(['orders', 'deliveryPlace']),
    stripeCustomer: state.getIn(['payments', 'stripeCustomer']),
    loading: (state.getIn(['products', 'loading']) || state.getIn(['payments', 'loading']) || state.getIn(['orders', 'loading'])),
    shippoLoading: (state.getIn(['orders', 'shippoLoading'])),
    error: state.getIn(['products', 'error']),
    cards: state.getIn(['payments', 'cards']),
    user: state.getIn(['users', 'user']),
    recentOrder: state.getIn(['orders', 'recentOrder'])
  };
})(ReviewOrderPage));



// WEBPACK FOOTER //
// ./src/containers/billing/checkout/ReviewOrderPage.js